<template>
  <div class="social-status ">
    <b-modal v-model="showConfirmCancel" type="warn" title="Confirm Cancellation" @ok="clickConfirmCancel" ok-title="Confirm">
			<p>Please enter a reason for cancelling the social post:</p>
      <b-form-textarea
        :id="`textConfirmCancel-${deliverable.id}`"
        v-model="textConfirmCancel"
        rows="3"
        ref="refTextConfirmCancel"
      ></b-form-textarea>
		</b-modal>
    <b-tooltip v-if="hasTooltip" :target="`social-status-label-${deliverable.id}`" triggers="hover">
      {{deliverable.publish_notes}}
    </b-tooltip>
    <div class="social-status-label exclude-outside-click" @click="clickStatusLabel" v-bind:style="{background: statusColor}" :id="`social-status-label-${deliverable.id}`">
      <span class="status-text">{{ statusText }}</span>
    </div>
    <div class="status-field exclude-outside-click">
      <multiselect
        ref="customInput"
        :searchable="false"
        v-show="showActionSelect"
        v-model="actionSelected"
        v-click-outside="clickOutside"
        :options="actionOptions"
        @close="showActionSelect=false"
        @input="clickAction(actionSelected)"
        @select="showActionSelect=false"
        :show-labels="false"
      >
        <template slot="option" slot-scope="props">
          <div
            :style="{ color: 'var(--wf-secondary)', borderRadius: '5px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
          >{{ props.option.name }}</div>
        </template>
      </multiselect>
    </div>
  </div>
</template>
<style scoped>
.social-status-label{
  padding: 10px 0px;
  color: var(--wf-secondary);
  font-weight: 600;
  cursor: pointer;
}
</style>

<script>
import { mapGetters, mapState } from "vuex";

export default{
  data() {
    return {
      buttonsDisabled: false,
      showConfirmCancel: false,
      textConfirmCancel: "",
      showActionSelect: false,
      actionSelected: false,
    }
  },
  props: ['deliverable', "namespace"],
  computed: {
    ...mapGetters([
      "systemSettings",
    ]),
    ...mapState({
      state(state) {
        return state[this.namespace]
      },
    }),


    publishStatus(){
      return JSON.parse(this.deliverable.publish_status);
    },
    statusColor(){
    	if (this.publishStatus) {
    	  return this.publishStatus.color;
    	}
    },
    statusText(){
    	if (this.publishStatus) {
	      return this.publishStatus.name;
	    }
    },
    statusSlug(){
      if (this.publishStatus) {
	      return this.publishStatus.slug;
	    }
    },
    hasTooltip(){
      if(this.deliverable.publish_notes){
        if(this.deliverable.publish_notes.length){
          return true;
        }
      }
      return false;
    },
    actionOptions(){
      let that = this;
      let options = [];
      if(this.systemSettings && this.systemSettings?.actions) {
      options = this.systemSettings?.actions?.filter(function(action){
        if(that.statusSlug == 'cancelled'){
          if(action.slug == 'undo-cancel-post'){
            return true;
          }
          return false;
        } else {
          if(action.slug == 'cancel-post'){
            return true;
          }
          return false;
        }
      });
      }
      return options;
    },
  },
  methods: {
    clickStatusLabel(){
      this.showActionSelect = true;
    },
    clickOutside(){
      this.showActionSelect = false;
    },
    clickAction(action){
      this.actionSelected = false;
      console.log("clickAction");
      console.log(action);
      if(action.slug == "cancel-post"){
        this.showConfirmCancel = true;
        this.$nextTick(() => {
 	       this.$refs.refTextConfirmCancel.focus();
        });
      } else {
        this.doAction(action);
      }
    },
    clickConfirmCancel(e){
      if(!this.textConfirmCancel.length){
        e.preventDefault();
        document.getElementById("textConfirmCancel-"+this.deliverable.id).focus();
        return;
      }
      this.buttonsDisabled = true;
      let that = this;
      that.$store.dispatch(that.namespace + "updateDeliverablePublishStatusBySlug", {
        id: that.deliverable.id,
        value: "cancelled",
        notes: that.textConfirmCancel
      }).then(function(){
        that.buttonsDisabled = false;
      });
    },
    doAction(action){
      this.$store.dispatch(this.namespace + "doAction",{
        deliverable_id: this.deliverable.id,
        action: action.slug,
      });
    }
  },
  created(){
    
  }
}
</script>